var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-card',{attrs:{"title":'User notes'}},[_c('user-notes',{attrs:{"user-id":_vm.userId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }